import { render, staticRenderFns } from "./area_distribute.vue?vue&type=template&id=30ef802c&scoped=true"
import script from "./area_distribute.vue?vue&type=script&lang=ts"
export * from "./area_distribute.vue?vue&type=script&lang=ts"
import style0 from "./area_distribute.vue?vue&type=style&index=0&id=30ef802c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef802c",
  null
  
)

export default component.exports